import { render, staticRenderFns } from "./consenTagrees.vue?vue&type=template&id=4dbb8141&scoped=true"
import script from "./consenTagrees.vue?vue&type=script&lang=js"
export * from "./consenTagrees.vue?vue&type=script&lang=js"
import style0 from "./consenTagrees.vue?vue&type=style&index=0&id=4dbb8141&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb8141",
  null
  
)

export default component.exports